// extracted by mini-css-extract-plugin
export default {"slider":"styles_slider__frO+X","card":"styles_card__ONI1s","bg":"styles_bg__4qy+K","phone":"styles_phone__ZxMhZ"};